import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function headerColorChange() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.to(
    {},
    {
      scrollTrigger: {
        trigger: '.js-headerTrigger', // トリガーとなるエリア
        start: 'top start', // エリアの上端が画面中央に来たら発火（調整可）
        onEnter: () => {
          document.querySelector('header').classList.add('is-scrolled'); // クラス付与
        },
        onLeaveBack: () => {
          document.querySelector('header').classList.remove('is-scrolled'); // クラスを外す
        },
        // once: true, // 一度きりの場合は追加
        // markers: true // デバッグ用
      },
    }
  );
}
